
export const ELEMENT_EDITOR_DOM_ID = 'element-editor';
